import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfigContext } from '../../Context/ConfigContext';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from "primereact/checkbox";
import { Skeleton } from 'primereact/skeleton';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import OrderPrint from '../PrintHelper/OrderPrint';


const Orders = () => {
    const toast = useRef(null);
    const { apiUrl, apiHeadersJson, baseurl, store_id, auth_routes } = useContext(ConfigContext);
    const [products, setProducts] = useState([]);
    const [isPrint, setisPrint] = useState(false);
    const [isFree, setisFree] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(1);
    const [saleType, setSaleType] = useState(2);
    const [onlineAmount, setOnlineAmount] = useState(null);
    const [cashAmount, setCashAmount] = useState(null);
    const [cardAmount, setCardAmount] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [storeInfo, setStoreInfo] = useState([]);
    const [focusedProduct, setFocusedProduct] = useState(null);
    const [addedProducts, setAddedProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [InvoiceNumber, setInvoiceNumber] = useState('');
    const [listLoading, setListLoading] = useState(true);
    const [addLoading, setAddLoading] = useState(false);
    const [saleLoading, setSaleLoading] = useState(false);
    const [customerId, setCustomerId] = useState('');
    const [customerInput, setCustomerInput] = useState("NA");
    const [expectedDate, setExpectedDate] = useState("");
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const headers = apiHeadersJson;
    const [Category] = useState(null);
    const { order_id, para_store_id } = useParams();
    const inputRefs = useRef({});
    const navigate = useNavigate();


    //print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);

    // //////////////// conform
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1
        }
    };


    const handleKeyboardInput = (num) => {
        if (focusedProduct !== null) {
            const product = addedProducts[focusedProduct];
            if (product) {
                const currentQty = (product.product_qty ?? '').toString();
                const newQty = parseInt(`${currentQty}${num}`, 10);
                handleInputChange(focusedProduct, 'product_qty', isNaN(newQty) ? 0 : newQty);
            }
        }
    };

    const handleClearInput = () => {
        if (focusedProduct !== null) {
            handleInputChange(focusedProduct, 'product_qty', 0);
        }
    };

    const handleBackspaceInput = () => {
        if (focusedProduct !== null) {
            const product = addedProducts[focusedProduct];
            if (product) {
                const currentQty = (product.product_qty ?? '0').toString();
                const newQtyStr = currentQty.slice(0, -1) || '0';
                const newQty = parseInt(newQtyStr, 10);
                handleInputChange(focusedProduct, 'product_qty', isNaN(newQty) ? 0 : newQty);
            }
        }
    };

    const filteredProducts = Category ? products.filter((product) => (product.category_id === Category.category_id) &&
        (product.product_name.toLowerCase().includes(searchTerm.toLowerCase())))
        : products.filter((product) =>
            product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
        );


    const handleAddProductByBarcode = async (value, type) => {
        if (!value) {
            const errorMsg = type === 'barcode' ? 'Barcode is empty' : 'Select Product First';
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: errorMsg,
                life: 1000,
            });
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
            return;
        }

        setAddLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetProductInfoByBarCode`, {
                params: { type, value },
                headers,
            });

            const audio = new Audio(`https://www.mamtafood.com/assets/audio/coin.mp3`);
            audio.play();
            setAddLoading(false);

            const { success, data, message } = response.data;

            if (success) {
                const product = data[0];

                if (product) {
                    // Determine sale rate based on saleType
                    const productRate = saleType === 1 ? product.product_retail_rate : product.product_sale_rate;

                    setAddedProducts((prev) => {
                        let updatedProducts = [...prev];
                        const existingProduct = prev.find((p) => p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0));

                        if (isFree) {
                            const freeProduct = prev.find((p) => p.product_id === product.product_id && p.stock_free != 0);
                            if (freeProduct) {
                                updatedProducts = prev.map((p) =>
                                    p.product_id === product.product_id && p.stock_free != 0
                                        ? { ...p, product_qty: p.product_qty + 1, stock_free: p.stock_free + 1 }
                                        : p
                                );
                            } else {
                                updatedProducts.push({ ...product, product_qty: 1, product_sale_rate: 0, stock_free: 1 });
                            }
                        } else {
                            if (existingProduct) {
                                updatedProducts = prev.map((p) =>
                                    p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0)
                                        ? { ...p, product_qty: p.product_qty + 1 }
                                        : p
                                );
                                const existingProductIndex = prev.findIndex(p => p.product_id === product.product_id && (!p.stock_free || p.stock_free === 0));
                                setFocusedProduct(existingProductIndex);
                            } else {
                                updatedProducts.push({
                                    ...product,
                                    product_qty: 1,
                                    product_sale_rate: productRate || 0,
                                    stock_free: 0
                                });
                                setFocusedProduct(addedProducts.length);
                            }
                        }

                        return updatedProducts;
                    });

                    if (navigator.vibrate) {
                        navigator.vibrate(200);
                    }
                } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Product not found',
                        life: 1000,
                    });
                    if (navigator.vibrate) {
                        navigator.vibrate(500);
                    }
                }
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: message,
                    life: 1000,
                });
            }
        } catch (error) {
            console.error("Error fetching product info:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Unable to fetch product info',
                life: 1000,
            });
            setAddLoading(false);
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
        } finally {
            setAddLoading(false);
        }
    };

    useEffect(() => {
        // Focus the last added product's input element
        if (focusedProduct !== null && inputRefs.current[focusedProduct]) {
            inputRefs.current[focusedProduct].focus();
            inputRefs.current[focusedProduct].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [focusedProduct]);

    useEffect(() => {
        let barcodeBuffer = '';
        let timer;
        const handleKeyPress = (event) => {
            clearTimeout(timer);

            if (event.key === 'Enter') {
                if (barcodeBuffer) {
                    handleAddProductByBarcode(barcodeBuffer, 'barcode');
                    barcodeBuffer = '';
                }
            } else {
                barcodeBuffer += event.key;
            }

            timer = setTimeout(() => {
                barcodeBuffer = '';
            }, 300);
        };

        window.addEventListener('keypress', handleKeyPress);

        return () => {
            window.removeEventListener('keypress', handleKeyPress);
        };
    }, [handleAddProductByBarcode]);

    const handleRemoveProduct = (index) => {
        setAddedProducts((prev) => prev.filter((_, i) => i !== index));
    };

    const handleCustomerInputChange = (e) => {
        const input = e.target.value;
        setCustomerInput(input);

        if (input.trim() === "") {
            setFilteredCustomers([]);
            setShowDropdown(false);
            setCustomerId("");
            return;
        }

        // Filter customers based on input
        const filtered = customers.filter(customer =>
            customer.customer_name.toLowerCase().includes(input.toLowerCase())
        );

        setFilteredCustomers(filtered);
        setShowDropdown(filtered.length > 0);

        // Check if input exactly matches an existing customer
        const existingCustomer = customers.find(customer =>
            customer.customer_name.toLowerCase() === input.toLowerCase()
        );

        if (existingCustomer) {
            setCustomerId(existingCustomer.customer_id);
        } else {
            setCustomerId("");
        }
    };

    const handleSelectCustomer = (customer) => {
        setCustomerInput(customer.customer_name);
        setCustomerId(customer.customer_id);
        setShowDropdown(false);
    };
    const handleMethodChange = (event) => {
        const selectedValue = parseInt(event.target.value, 10);
        setPaymentMethod(selectedValue);
    };
    const handleTypeChange = (event) => {
        const selectedType = Number(event.target.value);
        setSaleType(selectedType);
    };

    const handleInputChange = (index, field, value) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue)) {
            setAddedProducts((prev) =>
                prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
            );
        }
    };

    function generateInvoiceNumber() {
        if (order_id) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: "You Cannot Update the Invice Number", life: 1000 });
            return;
        }
        const prefix = "O-";
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        const invoiceNumber = prefix + randomNumber;
        setInvoiceNumber(invoiceNumber);
    }

    const handleResetForm = () => {
        setCustomerId('');
        setCustomerInput('NA');
        setInvoiceNumber('');
        setAddedProducts([]);
        if (order_id) {
            navigate('/OrderReport')
        }
    };
    const handleConfirm = async () => {
        setShowConfirmationDialog(true);
        CheckAmount();
    };

    const handleCancel = () => {
        setShowConfirmationDialog(false);
    };

    useEffect(() => {
        setCustomerId('');
        setCustomerInput('NA');
        setInvoiceNumber('');
        setAddedProducts([]);
    }, [store_id]);

    const handleSubmit = async () => {
        const total_adv = Number(cashAmount) + Number(onlineAmount) + Number(cardAmount);
        if (totalAmount < total_adv || total_adv < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please check the amount', life: 1000 });
            return;
        }
        const body = {
            order_id: order_id,
            customer_id: customerId,
            expected_date: expectedDate,
            customer_name: customerInput,
            invoice_number: InvoiceNumber,
            payment_method: paymentMethod,
            sale_rate_type: saleType,
            cash_amount: (paymentMethod === 1 || paymentMethod === 3) ? cashAmount : 0,
            online_amount: (paymentMethod === 2 || paymentMethod === 3) ? onlineAmount : 0,
            card_amount: (paymentMethod === 4) ? cardAmount : 0,
            grand_total_amount: totalAmount,
            store_id: store_id,
            rows: addedProducts,
        };

        try {
            setSaleLoading(true);
            const response = await axios.post(`${apiUrl}/Management/OrderProducts`, body, { headers });
            setSaleLoading(false);
            const { success, message, cr_order_id } = response.data;

            if (success) {
                if (isPrint) {
                    await handlePrint(cr_order_id);
                }
                handleResetForm();
                fetchDropdownData();
                setShowConfirmationDialog(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 1000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.log('error', error);
            setSaleLoading(false);
        }
    };

    // printcontroller
    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.puechase-invoice-container');
        if (!invoiceContainer) {
            alert("Order Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
                <html>
                    <head><style>${styles}</style></head>
                    <body>${invoiceContainer.innerHTML}</body>
                </html>
            `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/OrderInvoice`, { params: { order_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };


    const fetchDropdownData = async () => {
        try {
            setListLoading(true);
            const [productRes, customerRes, storeInfo] = await Promise.all([
                axios.get(`${apiUrl}/Masters/ProductListForOrder`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/GetCustomerList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/GetStoreInfo`, { params: { store_id: store_id }, headers }),
            ]);
            setListLoading(false);

            setProducts(productRes.data.data || []);
            setCustomers(customerRes.data.data || []);
            setStoreInfo(storeInfo.data.storePermissions || []);
        } catch (error) {
            setListLoading(false);
            console.error('Error fetching DropdownData:', error);
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, [store_id]);

    const calculateRowTotal = (product) => {
        const productRate = saleType === 1 ? product.product_retail_rate : product.product_sale_rate;
        return productRate * product.product_qty;
    };

    const calculateRowQty = (product) => {
        return product.product_qty;
    };

    // Function to calculate unique items based on product_id
    const calculateItems = () => {
        const uniqueProductIds = new Set(addedProducts.map(product => product.product_id));
        return uniqueProductIds.size;
    };

    const calculateQty = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowQty(product), 0);
    };

    const calculateTotalAmount = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowTotal(product), 0);
    };

    const discountedAmount = calculateTotalAmount();
    const totalAmount = Math.round(discountedAmount);
    const calculatedQty = calculateQty();
    const calculateditems = calculateItems();

    const CheckAmount = () => {
        const total_remaining = totalAmount * 0.5;
        const half_amount = total_remaining * 0.5;

        if (paymentMethod === 1) {
            setCashAmount(total_remaining);
            setCardAmount(0);
            setOnlineAmount(0);
        }
        if (paymentMethod === 2) {
            setOnlineAmount(total_remaining);
            setCashAmount(0);
            setCardAmount(0);
        }
        if (paymentMethod === 4) {
            setCardAmount(total_remaining);
            setOnlineAmount(0);
            setCashAmount(0);
        }
        if (paymentMethod === 3) {
            setOnlineAmount(half_amount);
            setCashAmount(half_amount);
            setCardAmount(0);
        }
    }

    useEffect(() => {
        CheckAmount();
    }, [paymentMethod]);

    useEffect(() => {
        if (auth_routes.includes('PrintOrder')) {
            setisPrint(true);
        }
    }, [auth_routes.length]);


    const GetList = async () => {
        try {
            const response = await axios.get(`${apiUrl}/Management/GetOrderProducts`, {
                params: { order_id, type: 0 },
                headers
            });
            const { success, data, rows, message } = response.data;
            if (success) {
                setAddedProducts(rows);
                setCustomerId(data[0].customer_id);
                setCustomerInput(data[0].customer_name);
                setExpectedDate(data[0].expected_date);
                setInvoiceNumber(data[0].invoice_number);
                if (data[0].adv_payment_method) {
                    setPaymentMethod(parseInt(data[0].adv_payment_method));
                }
                setSaleType(data[0].sale_rate_type);
                setOnlineAmount(data[0].adv_online_amount);
                setCashAmount(data[0].adv_cash_amount);
                setCardAmount(data[0].adv_card_amount);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 1000 });
        }
    };

    useEffect(() => {
        if (order_id) {
            GetList();
        }
    }, [order_id]);


    const PaymentMethods = [
        { value: 1, label: 'Cash' },
        { value: 2, label: 'Online' },
        { value: 3, label: 'Cash & Online' },
        { value: 4, label: 'Card' },
    ]
    const SaleTypes = [
        { value: 1, label: 'Retailer' },
        { value: 2, label: 'Whole sale' },
    ]

    return (

        <div className="container-fluid" style={{ background: 'hsl(120deg 100% 97.06%)' }}>
            <Dialog
                header="Confirm Order"
                visible={showConfirmationDialog}
                style={{ width: '35vw' }}
                onHide={handleCancel}
                footer={
                    <div>
                        <button className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                        </button>
                        <button className="btn btn-primary ml-2" onClick={handleSubmit} disabled={!expectedDate}>
                            {dataLoading ? 'Preparing Print....!' : order_id ? "Update" : "Confirm"}
                        </button>
                    </div>
                }
            >
                <div className="p-fluid">
                    <div className="row">
                        {/* Left Column */}
                        <div className="col-6">
                            {/* Customer Name */}
                            <div className="p-field">
                                <label htmlFor="customerName">Customer Name</label>
                                <InputText id="customerName" value={customerInput} onChange={(e) => setCustomerInput(e.target.value)} />
                            </div>

                            {/* Expected Delivery Date */}
                            <div className="p-field mt-2">
                                <label htmlFor="expectedDate">Expected Delivery Date</label>
                                <input
                                    id="expectedDate"
                                    type="date"
                                    className="form-control mt-2"
                                    value={expectedDate}
                                    onChange={(e) => setExpectedDate(e.target.value)}
                                />
                            </div>

                            {/* Payment Method */}
                            <div className="p-field mt-2">
                                <label htmlFor="paymentMethod">Payment Method</label>
                                <select
                                    className="form-select mt-1"
                                    value={paymentMethod || ""}
                                    onChange={handleMethodChange}
                                >
                                    <option value="" disabled>
                                        Select a Method
                                    </option>
                                    {PaymentMethods.map((method) => (
                                        <option key={method.value} value={method.value}>
                                            {method.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-6">
                            {/* Cash Amount */}
                            {paymentMethod === 1 || paymentMethod === 3 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="cashAmount">Cash Amount</label>
                                    <InputText id="cashAmount" value={cashAmount} onChange={(e) => setCashAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Online Amount */}
                            {paymentMethod === 2 || paymentMethod === 3 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="onlineAmount">Online Amount</label>
                                    <InputText id="onlineAmount" value={onlineAmount} onChange={(e) => setOnlineAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Card Amount */}
                            {paymentMethod === 4 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="cardAmount">Card Amount</label>
                                    <InputText id="cardAmount" value={cardAmount} onChange={(e) => setCardAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Total Amount */}
                            <div className="p-field mt-2">
                                <label htmlFor="totalAmount">Total Amount</label>
                                <InputText id="totalAmount" value={totalAmount} disabled />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Toast ref={toast} position="top-right" />
            <motion.div
                className="row pt-3 bg-light"
                style={{ borderBottom: "1px solid #000" }}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.1 }}
            >
                <div className="col-md-7">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h6>Order Entry</h6>
                        {auth_routes.includes('PrintOrder') && <label htmlFor="print">
                            <Checkbox checked={isPrint} id='print' className="me-2" onChange={(e) => { setisPrint(e.target.checked) }} />
                            Print
                        </label>}
                        <div className="">
                            <select
                                className="form-select form-select-sm"
                                value={paymentMethod || ""}
                                onChange={handleMethodChange}>

                                <option value="" disabled>
                                    Select a Method
                                </option>
                                {PaymentMethods.map((method) => (
                                    <option key={method.value} value={method.value}>
                                        {method.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {storeInfo?.includes('AmountType') && <div className="">
                            <select
                                className="form-select form-select-sm"
                                value={saleType || ""}
                                disabled={addedProducts.length != 0}
                                onChange={handleTypeChange}>
                                <option value="" disabled>
                                    Select a Type
                                </option>
                                {SaleTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>}
                    </div>
                </div>
                <div className="col-md-2">
                    <button className='btn btn-info btn-sm text-white w-100' onClick={() => window.open(`#/PrintOrder`)}>New Order</button>
                </div>
                <div className="col-md-3">
                    <div className="p-inputgroup flex-1">
                        <IconField iconPosition="left" className='w-100'>
                            <InputIcon className="pi pi-search"> </InputIcon>
                            <InputText placeholder="Search By Product Name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-100' style={{ height: '35px' }} />
                        </IconField>
                    </div>
                </div>
            </motion.div>

            <div className="row">
                <div className="col-md-6 border border-1 bg-light d-flex flex-column" style={{ height: "calc(100vh - 120px)" }}>
                    <motion.div
                        className="flex-grow-1"
                        style={{ overflowY: 'auto' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.1 }}
                    >
                        <table className="table m-0 table-hover table-bordered table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Rate</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {addedProducts.length > 0 ? (
                                <tbody>
                                    <AnimatePresence>
                                        {addedProducts.map((product, i) => (
                                            <motion.tr
                                                layout
                                                key={product.product_id}
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0, }}
                                                transition={{ duration: 0.1 }}
                                                onClick={() => { setFocusedProduct(i); }}
                                                className={focusedProduct === i ? 'border border-2 border-danger table-active' : ''}>
                                                <td className="w-25">{product.product_name}</td>
                                                <td>{saleType === 1 ? product.product_retail_rate : product.product_sale_rate}</td>
                                                <td style={{ width: '130px' }}>
                                                    <div className="d-flex">
                                                        <button
                                                            type="button"
                                                            disabled={product.product_qty <= 1 || product.stock_free !== 0}
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                handleInputChange(i, 'product_qty', product.product_qty - 1)
                                                            }
                                                        >
                                                            <i className="pi pi-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            className="form-control p-1"
                                                            placeholder="Qty"
                                                            value={product.product_qty}
                                                            disabled={product.stock_free !== 0}
                                                            ref={(el) => (inputRefs.current[i] = el)}
                                                            onFocus={() => setFocusedProduct(i)}
                                                            onChange={(e) =>
                                                                handleInputChange(i, 'product_qty', Number(e.target.value))
                                                            }
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-success btn-sm"
                                                            disabled={product.stock_free !== 0}
                                                            onClick={() =>
                                                                handleInputChange(i, 'product_qty', product.product_qty + 1)
                                                            }
                                                        >
                                                            <i className="pi pi-plus"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{calculateRowTotal(product).toFixed(2)}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleRemoveProduct(i)}
                                                    >
                                                        <i className="pi pi-trash"></i>
                                                    </button>
                                                </td>
                                            </motion.tr>
                                        ))}
                                    </AnimatePresence>
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td className="w-25 text-muted" colSpan={6}>
                                            Add Products ..........!
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </motion.div>

                    <motion.div
                        className="row my-3"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <div className="col-md-6">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={customerInput}
                                    onChange={handleCustomerInputChange}
                                    placeholder="Type or select a customer"
                                    onFocus={() => setShowDropdown(filteredCustomers.length > 0)}
                                    onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                />

                                {showDropdown && (
                                    <ul className="list-group position-absolute w-100 shadow bg-white" style={{ maxHeight: "200px", overflowY: "auto", zIndex: 10 }}>
                                        {filteredCustomers.map(customer => (
                                            <li
                                                key={customer.customer_id}
                                                className="list-group-item list-group-item-action small"
                                                onMouseDown={() => handleSelectCustomer(customer)}
                                            >
                                                {customer.customer_name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group">
                                <button
                                    onClick={generateInvoiceNumber}
                                    className="btn bg-primary d-flex align-items-center justify-content-center"
                                    style={{ width: '40px' }}
                                    type="button"
                                >
                                    <i className="pi pi-refresh"></i>
                                </button>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Invoice No"
                                    value={InvoiceNumber}
                                    disabled
                                    style={{ height: '35px' }}
                                />
                            </div>
                        </div>
                    </motion.div>
                    <div className="row bg-danger mt-auto">
                        <div className="col-md-6">
                            <div className="row mt-1">
                                <div className="col-md-12 d-flex justify-content-between">
                                    <small className="text-light">
                                        Total Products: <strong>{calculateditems}</strong>
                                    </small>
                                    <small className="text-light">
                                        Total Qty: <strong>{calculatedQty}</strong>
                                    </small>
                                </div>

                                <div className="col-md-12 mt-2">
                                    <small className="text-light">
                                        Total Amount: <strong>₹{totalAmount.toFixed(2)}</strong>
                                    </small>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="row d-flex justify-content-center align-items-center mt-3">
                                <button
                                    className="btn btn-success btn-sm w-75"
                                    onClick={handleConfirm}
                                    disabled={dataLoading || saleLoading || !InvoiceNumber || addedProducts.length === 0}
                                >
                                    {dataLoading ? 'Preparing Print....!' : saleLoading ? "Loading..!" : order_id ? "Update" : "Order"}
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row gx-7 gy-7">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, i) => (
                                    <motion.div
                                        key={num}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: i * 0.09 }}
                                        className="col-4"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-outline-light w-100 btn-sm"
                                            key={num}
                                            onClick={() => handleKeyboardInput(num)}
                                        >
                                            {num}
                                        </button>
                                    </motion.div>
                                ))}
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning w-100 btn-sm"
                                        onClick={handleClearInput}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-danger w-100 btn-sm"
                                        onClick={handleBackspaceInput}
                                    >
                                        <i className='pi pi-delete-left'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="col-md-6">
                    <div className="h-100 rounded-0" style={{
                        background: 'linear-gradient(90deg, #e4e8eb 0%,rgb(250, 250, 250) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        <div
                            style={{
                                flex: 1,
                                overflowY: 'auto',
                                padding: '0px 12px',
                                maxHeight: "calc(100vh - 120px)",
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                        >
                            {listLoading ? (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {[...Array(12)].map((_, i) => (
                                        <motion.div
                                            className="col-4 col-md-4"
                                            key={i}
                                            variants={itemVariants}
                                        >
                                            <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                                <h6 className="card-title text-truncate"><Skeleton width='100%' height='18vh'></Skeleton></h6>
                                                <div className="card-body">
                                                    <Skeleton width="100%" height="20px" className="mb-2" />
                                                    <div className="d-flex justify-content-between">
                                                        <Skeleton width="60px" height="16px" />
                                                        <Skeleton width="40px" height="16px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    ))}
                                </motion.div>
                            ) :
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {filteredProducts.length > 0 ? (
                                        filteredProducts.map((product, i) => (
                                            <motion.div
                                                layout
                                                key={i}
                                                className="col-3 col-md-3"
                                                initial={{ opacity: 0, scale: 0.95 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.1 }}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                            >
                                                <div
                                                    className={`card h-100 border-0 shadow-sm overflow-hidden position-relative ${addLoading ? 'pe-none' : ''}`}
                                                    onClick={() => {
                                                        if (addLoading) return;
                                                        handleAddProductByBarcode(product.product_id, 'id');
                                                    }}
                                                    style={{
                                                        cursor: addLoading ? 'wait' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        opacity: addLoading ? 0.7 : 1
                                                    }}
                                                >
                                                    <div className="ratio ratio-1x1 bg-light">
                                                        <img
                                                            src={product.product_image_url}
                                                            loading='lazy'
                                                            className="card-img-top p-2 object-fit-contain"
                                                            alt={product.product_name}
                                                            style={{ transition: 'transform 0.3s ease' }}
                                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                        />
                                                    </div>
                                                    <div className="card-body p-3">
                                                        <h6 className="card-title text-truncate mb-2" style={{ fontSize: '0.9rem' }}>
                                                            {product.product_name}
                                                        </h6>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small">{saleType === 1 ? <> ₹{product.product_retail_rate}</> : <> ₹{product.product_sale_rate}</>}</span>
                                                            <div className="d-flex align-items-center">
                                                                {product.product_min_alert > product.total_remaining && (
                                                                    <i className="pi pi-exclamation-circle text-danger small"></i>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {addLoading && !listLoading && (
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            <div className="spinner-border text-primary" role="status"></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </motion.div>
                                        ))
                                    ) : (
                                        <motion.div
                                            className="col-12"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                        >
                                            <div className="text-center py-5">
                                                <i className="pi pi-search text-muted" style={{ fontSize: '2.5rem' }}></i>
                                                <h6 className="mt-3 text-muted">No products found</h6>
                                                <p className="small text-muted">Try changing your search or filters</p>
                                            </div>
                                        </motion.div>
                                    )}
                                </motion.div>}
                        </div>
                    </div>
                </div>
            </div>
            {isReadyToPrint && <OrderPrint orderDetails={invoiceData} products={printProducts} user={user} isShow={false} />}
        </div >
    );
};

export default Orders;
